export const ACTION_TYPE = {
	USER_LOGIN: "USER-LOGIN",
	USER_LOGOUT: "USER_LOGOUT",
	SET_ERROR: "SET_ERROR",
	USER_SIGNUP: "USER_SIGNUP",
	SET_USER: "SET_USER",
	SET_LOADING: "SET_LOADING",
	GET_CATEGORIES: "GET_CATEGORIES",
	GET_QUIZZES: "GET_QUIZZES",
	SET_CURRENT_QUS: "SET_CURRENT_QUS",
	SET_CURRENT_INDEX: "SET_CURRENT_INDEX",
	SET_USER_ANS: "SET_USER_ANS",
	SET_USER_SCORE:"SET_USER_SCORE",
	CLEAR_ALL: "CLEAR_ALL",
};
